import { render, staticRenderFns } from "./NewFapiao.vue?vue&type=template&id=27160b7a&scoped=true"
import script from "./NewFapiao.vue?vue&type=script&lang=js"
export * from "./NewFapiao.vue?vue&type=script&lang=js"
import style0 from "./NewFapiao.vue?vue&type=style&index=0&id=27160b7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27160b7a",
  null
  
)

export default component.exports